export const IN_PROGRESS_ID = "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d";

export const MAP_SERVICES_LIST = [
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 7,
    ResourceCountTotal: 23,
    ResourceCountUntagged: 16,
    ServiceName: "Amazon Simple Storage Service",
    TotalCost: 2624,
    TotalCostTagged: 800,
    TotalCostUntagged: 1824,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 1,
    ResourceCountTotal: 3,
    ResourceCountUntagged: 2,
    ServiceName: "AWS Security Hub",
    TotalCost: 600,
    TotalCostTagged: 200,
    TotalCostUntagged: 400,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 4,
    ResourceCountTotal: 11,
    ResourceCountUntagged: 7,
    ServiceName: "Amazon FSx",
    TotalCost: 3025,
    TotalCostTagged: 1100,
    TotalCostUntagged: 1925,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 10,
    ResourceCountTotal: 12,
    ResourceCountUntagged: 2,
    ServiceName: "Amazon Elastic Container Service for Kubernetes",
    TotalCost: 2640,
    TotalCostTagged: 2200,
    TotalCostUntagged: 440,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 12,
    ResourceCountTotal: 30,
    ResourceCountUntagged: 18,
    ServiceName: "Amazon Elastic Container Service",
    TotalCost: 3750,
    TotalCostTagged: 1500,
    TotalCostUntagged: 2250,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 8,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 0,
    ServiceName: "AWS Network Firewall",
    TotalCost: 1600,
    TotalCostTagged: 1600,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 8,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 0,
    ServiceName: "Amazon Neptune",
    TotalCost: 3200,
    TotalCostTagged: 3200,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 10,
    ResourceCountTotal: 11,
    ResourceCountUntagged: 1,
    ServiceName: "Amazon Relational Database Service",
    TotalCost: 5060,
    TotalCostTagged: 4600,
    TotalCostUntagged: 460,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 17,
    ResourceCountUntagged: 12,
    ServiceName: "Amazon Route 53",
    TotalCost: 2550,
    TotalCostTagged: 750,
    TotalCostUntagged: 1800,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 9,
    ResourceCountTotal: 9,
    ResourceCountUntagged: 0,
    ServiceName: "Amazon Comprehend",
    TotalCost: 1800,
    TotalCostTagged: 1800,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 6,
    ResourceCountUntagged: 1,
    ServiceName: "Amazon Elastic MapReduce",
    TotalCost: 5160,
    TotalCostTagged: 4300,
    TotalCostUntagged: 860,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 3,
    ResourceCountTotal: 6,
    ResourceCountUntagged: 3,
    ServiceName: "Amazon Managed Streaming for Apache Kafka",
    TotalCost: 7601,
    TotalCostTagged: 3800,
    TotalCostUntagged: 3801,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 6,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 2,
    ServiceName: "Amazon SageMaker",
    TotalCost: 2534,
    TotalCostTagged: 1900,
    TotalCostUntagged: 634,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 3,
    ResourceCountTotal: 3,
    ResourceCountUntagged: 0,
    ServiceName: "AWS Database Migration Service",
    TotalCost: 900,
    TotalCostTagged: 900,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 4,
    ResourceCountTotal: 7,
    ResourceCountUntagged: 3,
    ServiceName: "Amazon OpenSearch Service",
    TotalCost: 3675,
    TotalCostTagged: 2100,
    TotalCostUntagged: 1575,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 15,
    ResourceCountUntagged: 10,
    ServiceName: "AWS Systems Manager",
    TotalCost: 1200,
    TotalCostTagged: 400,
    TotalCostUntagged: 800,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 8,
    ResourceCountTotal: 20,
    ResourceCountUntagged: 12,
    ServiceName: "AWS Secrets Manager",
    TotalCost: 1056,
    TotalCostTagged: 420,
    TotalCostUntagged: 636,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 3,
    ServiceName: "Amazon AppStream",
    TotalCost: 2240,
    TotalCostTagged: 1400,
    TotalCostUntagged: 840,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 12,
    ResourceCountTotal: 32,
    ResourceCountUntagged: 20,
    ServiceName: "AWS Key Management Service",
    TotalCost: 1060,
    TotalCostTagged: 400,
    TotalCostUntagged: 660,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 8,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 0,
    ServiceName: "Amazon API Gateway",
    TotalCost: 1400,
    TotalCostTagged: 1400,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 22,
    ResourceCountTotal: 37,
    ResourceCountUntagged: 15,
    ServiceName: "AWS Lambda",
    TotalCost: 5885,
    TotalCostTagged: 3500,
    TotalCostUntagged: 2385,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 10,
    ResourceCountTotal: 12,
    ResourceCountUntagged: 2,
    ServiceName: "Amazon Elastic File System",
    TotalCost: 2160,
    TotalCostTagged: 1800,
    TotalCostUntagged: 360,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 3,
    ResourceCountTotal: 7,
    ResourceCountUntagged: 4,
    ServiceName: "Amazon Kinesis",
    TotalCost: 2100,
    TotalCostTagged: 900,
    TotalCostUntagged: 1200,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 25,
    ResourceCountTotal: 55,
    ResourceCountUntagged: 30,
    ServiceName: "Amazon Elastic Compute Cloud",
    TotalCost: 11660,
    TotalCostTagged: 5300,
    TotalCostUntagged: 6360,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 14,
    ResourceCountUntagged: 9,
    ServiceName: "Elastic Load Balancing",
    TotalCost: 3360,
    TotalCostTagged: 1200,
    TotalCostUntagged: 2160,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 3,
    ResourceCountTotal: 3,
    ResourceCountUntagged: 0,
    ServiceName: "AWS Glue",
    TotalCost: 2100,
    TotalCostTagged: 2100,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 10,
    ResourceCountTotal: 20,
    ResourceCountUntagged: 10,
    ServiceName: "AmazonCloudWatch",
    TotalCost: 500,
    TotalCostTagged: 250,
    TotalCostUntagged: 250,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 7,
    ResourceCountUntagged: 2,
    ServiceName: "Amazon ElastiCache",
    TotalCost: 1232,
    TotalCostTagged: 880,
    TotalCostUntagged: 352,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 3,
    ResourceCountTotal: 3,
    ResourceCountUntagged: 0,
    ServiceName: "Amazon Redshift",
    TotalCost: 750,
    TotalCostTagged: 750,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 2,
    ResourceCountTotal: 22,
    ResourceCountUntagged: 20,
    ServiceName: "AWS Data Pipeline",
    TotalCost: 4950,
    TotalCostTagged: 450,
    TotalCostUntagged: 4500,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 8,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 0,
    ServiceName: "Amazon Simple Notification Service",
    TotalCost: 700,
    TotalCostTagged: 700,
    TotalCostUntagged: 0,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 11,
    ResourceCountUntagged: 6,
    ServiceName: "Amazon DynamoDB",
    TotalCost: 1430,
    TotalCostTagged: 650,
    TotalCostUntagged: 780,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 5,
    ResourceCountTotal: 11,
    ResourceCountUntagged: 6,
    ServiceName: "Amazon Virtual Private Cloud",
    TotalCost: 902,
    TotalCostTagged: 410,
    TotalCostUntagged: 492,
  },
  {
    CurrencyCode: "USD",
    MapProjectId: "1b413d01-5ea2-46b2-b9e6-41ceaf61e93d",
    ResourceCountTagged: 2,
    ResourceCountTotal: 8,
    ResourceCountUntagged: 6,
    ServiceName: "AWS CloudShell",
    TotalCost: 960,
    TotalCostTagged: 240,
    TotalCostUntagged: 720,
  },
];
